import _definePage_default_0 from '/app/src/features/document-manager/pages/index.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/app/src/pages/help.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/app/src/features/home/pages/project-selection.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/app/src/features/load-sheet/pages/commits/index.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/app/src/features/load-sheet/pages/pending-reviews/index.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/app/src/features/load-sheet/pages/reviews/index.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/app/src/pages/login.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/app/src/pages/logs.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/app/src/features/project-administration/pages/project-settings.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/app/src/features/project-management/pages/index.vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/app/src/features/project-management/pages/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_12 from '/app/src/features/project-management/pages/create.vue?definePage&vue&lang.tsx'
import _definePage_default_13 from '/app/src/features/reports/pages/index.vue?definePage&vue&lang.tsx'
import _definePage_default_14 from '/app/src/features/reports/pages/criticality.vue?definePage&vue&lang.tsx'
import _definePage_default_15 from '/app/src/features/reports/pages/integrity-check.vue?definePage&vue&lang.tsx'
import _definePage_default_16 from '/app/src/features/spares/pages/billofmaterials/index.vue?definePage&vue&lang.tsx'
import _definePage_default_17 from '/app/src/features/spares/pages/billofmaterials/[billOfMaterialId].vue?definePage&vue&lang.tsx'
import _definePage_default_18 from '/app/src/features/spares/pages/billofmaterials/create.vue?definePage&vue&lang.tsx'
import _definePage_default_19 from '/app/src/features/spares/pages/materials.vue?definePage&vue&lang.tsx'
import _definePage_default_20 from '/app/src/features/user-management/pages/index.vue?definePage&vue&lang.tsx'
import _definePage_default_21 from '/app/src/features/user-profile/pages/index.vue?definePage&vue&lang.tsx'

export const routes = [
  {
    path: '/asset-hierarchy',
    /* internal name: '/asset-hierarchy' */
    /* no component */
    children: [
      {
        path: '',
        name: '/asset-hierarchy/',
        component: () => import('/app/src/features/asset-hierarchy/pages/index.vue'),
        /* no children */
      },
      {
        path: 'initialize',
        name: '/asset-hierarchy/initialize',
        component: () => import('/app/src/features/asset-hierarchy/pages/initialize.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/asset-support-types',
    /* internal name: '/asset-support-types' */
    /* no component */
    children: [
      {
        path: '',
        name: '/asset-support-types/',
        component: () => import('/app/src/features/asset-support-types/pages/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/document-manager',
    /* internal name: '/document-manager' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/document-manager/',
          component: () => import('/app/src/features/document-manager/pages/index.vue'),
          /* no children */
        },
        _definePage_default_0
      )
    ],
  },
  _mergeRouteRecord(
    {
      path: '/help',
      name: '/help',
      component: () => import('/app/src/pages/help.vue'),
      /* no children */
    },
    _definePage_default_2
  ),
  {
    path: '/home',
    /* internal name: '/home' */
    /* no component */
    children: [
      {
        path: '',
        name: '/home/',
        component: () => import('/app/src/features/home/pages/index.vue'),
        /* no children */
      },
      _mergeRouteRecord(
        {
          path: 'project-selection',
          name: '/home/project-selection',
          component: () => import('/app/src/features/home/pages/project-selection.vue'),
          /* no children */
        },
        _definePage_default_3
      )
    ],
  },
  {
    path: '/load-sheet',
    /* internal name: '/load-sheet' */
    /* no component */
    children: [
      {
        path: '',
        name: '/load-sheet/',
        component: () => import('/app/src/features/load-sheet/pages/index.vue'),
        /* no children */
      },
      {
        path: 'commits',
        /* internal name: '/load-sheet/commits' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/load-sheet/commits/',
              component: () => import('/app/src/features/load-sheet/pages/commits/index.vue'),
              /* no children */
            },
            _definePage_default_4
          ),
          {
            path: ':id',
            name: '/load-sheet/commits/[id]',
            component: () => import('/app/src/features/load-sheet/pages/commits/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'pending-reviews',
        /* internal name: '/load-sheet/pending-reviews' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/load-sheet/pending-reviews/',
              component: () => import('/app/src/features/load-sheet/pages/pending-reviews/index.vue'),
              /* no children */
            },
            _definePage_default_5
          )
        ],
      },
      {
        path: 'reviews',
        /* internal name: '/load-sheet/reviews' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/load-sheet/reviews/',
              component: () => import('/app/src/features/load-sheet/pages/reviews/index.vue'),
              /* no children */
            },
            _definePage_default_6
          )
        ],
      },
      {
        path: 'sessions',
        /* internal name: '/load-sheet/sessions' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/load-sheet/sessions/[id]',
            component: () => import('/app/src/features/load-sheet/pages/sessions/[id].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/load-sheet-backups',
    /* internal name: '/load-sheet-backups' */
    /* no component */
    children: [
      {
        path: '',
        name: '/load-sheet-backups/',
        component: () => import('/app/src/features/load-sheet-backups/pages/index.vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
    {
      path: '/login',
      name: '/login',
      component: () => import('/app/src/pages/login.vue'),
      /* no children */
    },
    _definePage_default_7
  ),
  _mergeRouteRecord(
    {
      path: '/logs',
      name: '/logs',
      component: () => import('/app/src/pages/logs.vue'),
      /* no children */
    },
    _definePage_default_8
  ),
  {
    path: '/project-administration',
    /* internal name: '/project-administration' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: 'project-settings',
          name: '/project-administration/project-settings',
          component: () => import('/app/src/features/project-administration/pages/project-settings.vue'),
          /* no children */
        },
        _definePage_default_9
      )
    ],
  },
  {
    path: '/project-management',
    /* internal name: '/project-management' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/project-management/',
          component: () => import('/app/src/features/project-management/pages/index.vue'),
          /* no children */
        },
        _definePage_default_10
      ),
      _mergeRouteRecord(
        {
          path: ':id',
          name: '/project-management/[id]',
          component: () => import('/app/src/features/project-management/pages/[id].vue'),
          /* no children */
        },
        _definePage_default_11
      ),
      _mergeRouteRecord(
        {
          path: 'create',
          name: '/project-management/create',
          component: () => import('/app/src/features/project-management/pages/create.vue'),
          /* no children */
        },
        _definePage_default_12
      )
    ],
  },
  {
    path: '/reports',
    /* internal name: '/reports' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/reports/',
          component: () => import('/app/src/features/reports/pages/index.vue'),
          /* no children */
        },
        _definePage_default_13
      ),
      _mergeRouteRecord(
        {
          path: 'criticality',
          name: '/reports/criticality',
          component: () => import('/app/src/features/reports/pages/criticality.vue'),
          /* no children */
        },
        _definePage_default_14
      ),
      _mergeRouteRecord(
        {
          path: 'integrity-check',
          name: '/reports/integrity-check',
          component: () => import('/app/src/features/reports/pages/integrity-check.vue'),
          /* no children */
        },
        _definePage_default_15
      )
    ],
  },
  {
    path: '/search-asset',
    /* internal name: '/search-asset' */
    /* no component */
    children: [
      {
        path: '',
        name: '/search-asset/',
        component: () => import('/app/src/features/search-asset/pages/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/spares',
    /* internal name: '/spares' */
    /* no component */
    children: [
      {
        path: 'billofmaterials',
        /* internal name: '/spares/billofmaterials' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/spares/billofmaterials/',
              component: () => import('/app/src/features/spares/pages/billofmaterials/index.vue'),
              /* no children */
            },
            _definePage_default_16
          ),
          _mergeRouteRecord(
            {
              path: ':billOfMaterialId',
              name: '/spares/billofmaterials/[billOfMaterialId]',
              component: () => import('/app/src/features/spares/pages/billofmaterials/[billOfMaterialId].vue'),
              /* no children */
            },
            _definePage_default_17
          ),
          _mergeRouteRecord(
            {
              path: 'create',
              name: '/spares/billofmaterials/create',
              component: () => import('/app/src/features/spares/pages/billofmaterials/create.vue'),
              /* no children */
            },
            _definePage_default_18
          )
        ],
      },
      _mergeRouteRecord(
        {
          path: 'materials',
          name: '/spares/materials',
          component: () => import('/app/src/features/spares/pages/materials.vue'),
          /* no children */
        },
        _definePage_default_19
      )
    ],
  },
  {
    path: '/user-management',
    /* internal name: '/user-management' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/user-management/',
          component: () => import('/app/src/features/user-management/pages/index.vue'),
          /* no children */
        },
        _definePage_default_20
      )
    ],
  },
  {
    path: '/user-profile',
    /* internal name: '/user-profile' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/user-profile/',
          component: () => import('/app/src/features/user-profile/pages/index.vue'),
          /* no children */
        },
        _definePage_default_21
      )
    ],
  },
  {
    path: '/validation-rules',
    /* internal name: '/validation-rules' */
    /* no component */
    children: [
      {
        path: '',
        name: '/validation-rules/',
        component: () => import('/app/src/features/validation-rules/pages/index.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

